import React from 'react'
import './ProjectCard.css'

const ProjectCard = ({ project }) => {
  let { link, company, title, info, stack } = project
  return (
    <a
      className="project-link"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="project-card-wrapper">
        <div className="project-card">
          <div className="project-card-top">
            <div
              className="project-bg"
              style={{ background: project.colourPrimary }}
            ></div>
            <div className="image-wrapper">
              <div
                className="project-bg logo-bg"
                style={{
                  background: project.colourSecondary
                    ? project.colourSecondary
                    : project.colourPrimary,
                }}
              ></div>
              <img
                className="company-logo"
                src={require(`../../images/logos/${company
                  .replace(/ /g, '')
                  .toLowerCase()}.png`)}
                alt={`${company}-logo`}
                style={
                  project.logoheight
                    ? {
                        height: `${project.logoheight}%`,
                      }
                    : { width: `${project.logowidth}%` }
                }
              />
            </div>
          </div>
          <div className="project-card-bottom">
            <div>
              <h2>{title}</h2>
              <ul>
                {info.map((point, idx) => (
                  <li key={`${company}-point-${idx}`}>{point}</li>
                ))}
              </ul>
            </div>
            <div className="project-card-tech">
              <ul>
                {stack.map((tech) => (
                  <li key={`${company}-${tech}`}>{tech}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </a>
  )
}

export default ProjectCard
